module.exports = __webpack_public_path__ + "img/faceTwoBg.b942f18b.png";